import { h } from 'preact';
import style from "./style.css";
import cx from 'classnames';

const LookingForTheFuture = () => (
    <div className={cx(style.lookingForTheFuture, 'flex')}>
        <div className={cx('flex', 'flex-col', 'items-center', 'justify-center')} style={{marginTop: '70px'}}>
            <div className={cx(style.futureText, 'flex', 'flex-col')}>
                <div className={cx('labelBoxLine', 'flex')}></div>
                <div className={cx('subTitleText', 'flex')}>LOOKING TO THE FUTURE</div>
                <div className={cx(style.subTitleBlock, 'flex')}>Our Player Index algorithm makes it easy for us to roll out a football product into all leagues in all countries, including all tournaments. i.e. World Cup, Euro’s, Champions League. We are in the early stages of developing an NFL product, with a view to extending into all major sports in time.</div>
            </div>
        </div>
        <div className={cx("flex")}></div>
    </div>
);

function FutureLogo(props) {
    return <div className={cx('flex', 'items-center', 'justify-center')} style={{width: '140px', height: '140px', backgroundColor: '#F2F2F2'}}><img style={{width: '60px', height: 'initial'}} src={props.imgUrl} /></div>;
}

export default LookingForTheFuture;


// WEBPACK FOOTER //
// ./components/LookingForTheFuture/index.jsx